export class CredentialsProfileGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetServiceAccountEmail",
            "baseName": "targetServiceAccountEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpProjectId",
            "baseName": "gcpProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloadIdentityPool",
            "baseName": "workloadIdentityPool",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CredentialsProfileGcp.attributeTypeMap;
    }
    constructor() {
    }
}
